// extracted by mini-css-extract-plugin
export default {"container":"style_container__Gtpdp","content":"style_content__WP7tm","title":"style_title__F0Qe2","title_header":"style_title_header__7JSOL","title_inner":"style_title_inner__724tP"};